// useMeta now lives in a session-wide provider (loads once, not per page).
// Re-exported here so existing `import { useMeta } from "../hooks"` keep working.
export { useMeta } from "./store/meta";

const DEFAULT_UI_PREFS = { default_view: "kanban", hidden_kanban_statuses: [], density: "comfortable" };

// Parses User.ui_prefs (a JSON string) with safe defaults — shared by every
// page that needs the user's saved view/density/hidden-columns preferences.
export function parseUiPrefs(user) {
  try { return { ...DEFAULT_UI_PREFS, ...(user?.ui_prefs ? JSON.parse(user.ui_prefs) : {}) }; }
  catch { return DEFAULT_UI_PREFS; }
}
